import { AfterViewInit, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import Swal from "sweetalert2";
import { ChargesService } from "src/app/services/system-config/charges/charges.service";
import { VendorService } from "src/app/services/vendor.service";
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, from, lastValueFrom, map } from "rxjs";
import { GeoService } from "src/app/services/geo.service";
import { CustomerService } from "src/app/services/customer.service";
import { pincodePattern, PincodeValidation } from "src/app/models/validator";
import { AppCoreService } from "src/app/services/app-core.service";
import { Title } from "@angular/platform-browser";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { AddODAComponent } from "./add/add.component";
import { ExcelService } from "src/app/services/excel.service";
import { Utilities } from "src/app/models/utilities";
import { EditDeleteActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/edit-delete.component";
@Component({
    selector: 'app-oda',
    templateUrl: './oda.component.html',
    styleUrls: ['./oda.component.scss'],
    encapsulation: ViewEncapsulation.None, // Disable encapsulation
})

export class ODAChargesComponent implements OnInit, AfterViewInit {
    odaChargesForm: FormGroup;
    isFormSubmitted = false;
    Id: number;
    typeList: any[] = [{ name: 'Customer' }, { name: 'Vendor' }, { name: 'Tariff' }]
    serviceList: any[];
    countryList: any[];
    stateList: any[];
    cityList: any[];
    pincodeList: any[];
    vendorList: any[];
    customerList: any[];
    countryCode: string;
    chargeType: any;
    CustomerType: boolean
    isActionAllowed = true;
    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
    };

    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;
    defaultColDef = {
        sortable: true,
        resizable: false,
    };

    gridOptions: GridOptions = {
        pagination: true,
        paginationPageSize: 10,
        domLayout: 'autoHeight'
    }

    columnDefs = [
        { headerName: 'Customer', field: 'customer', filter: true },
        { headerName: 'Vendor', field: 'vendor', filter: true },
        { headerName: 'Service', field: 'service', filter: true },
        { headerName: 'Destination Country', field: 'country', filter: true },
        { headerName: 'Destination State', field: 'state', filter: true },
        { headerName: 'Destination City', field: 'city', filter: true },
        { headerName: 'Pincode', field: 'pincode', filter: true },
        {
            headerName: 'ODA',
            field: 'is_oda',
            cellRenderer: (params: { value: string; }) => {
                let statusHtml = '<span class="badge bg-dark">No</span>';
                if (params.value === 'YES') {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            }
        },
        {
            headerName: 'Serviceable',
            field: 'is_serviceable',
            cellRenderer: (params: { value: string; }) => {
                let statusHtml = '<span class="badge bg-dark">No</span>';
                if (params.value === 'YES') {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            }
        },
        {
            headerName: 'Actions',
            field: 'id',
            // cellRendererParams: { context: this },
            cellRenderer: EditDeleteActionsRenderer,
            colId: 'params',
            editable: false,
            sortable: false,
            minWidth: 150,
        },
    ];
    rowData = [];
    editMode = false;
    useEnterKey = false;
    minPincode
    maxPincode
    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private ngxLoaderService: NgxUiLoaderService,
        private chargesService: ChargesService,
        private vendorService: VendorService,
        private geoService: GeoService,
        private customerService: CustomerService,
        private appCoreService: AppCoreService,
        private titleService: Title,
        public modalService: NgbModal,
        public excelService: ExcelService,
        public utilities: Utilities,

    ) {
        this.titleService.setTitle('Charges');
        this.context = { componentParent: this };
    }

    ngOnInit(): void {
        this.CustomerType = true
        // this.Id = this.route.snapshot.params['id']
        this.odaChargesForm = this.formBuilder.group({
            txtPincode: [null],
            ddlCustomer: [null],
            ddlVendor: [null],
            ddlService: [null],
            // txtODASwitch: [false],
            // txtServiceableSwitch: [false],
            ddlCountry: [null],
            ddlState: [null],
            ddlCity: [null]
        });
        // this.getAllODAList();
        this.bindPincodes();
        this.bindCountries();
        this.getAllCustomers();
        this.getAllVendors();
        this.checkPermission();
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.odaChargesForm) : null;
        this.searchODA(true);
    }

    checkPermission(): any {
        const userData = this.appCoreService.GetUserData();
        this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
        const permission = userData.config.filter(x => x.categoryname === 'ODA');
        if (permission.length) {
            this.permConfig.isViewAllowed = permission[0].view;
            this.permConfig.isAddAllowed = permission[0].add;
            this.permConfig.isEditAllowed = permission[0].edit;
            this.permConfig.isDeleteAllowed = permission[0].delete;
        }
    }

    setPincodeValidation() {
        if (this.odaChargesForm) {
            const pincodeControl = this.odaChargesForm.get('txtPincode');

            if (typeof pincodeControl?.value === 'string') {
                // Find the country code based on isocode
                const matchedCountryCode = this.countryList.find(x => x.isocode === this.countryCode)?.code;
                if (matchedCountryCode && pincodePattern[matchedCountryCode]) {
                    // Get the pattern for the selected country
                    const pattern = pincodePattern[matchedCountryCode];
                    // console.log(this.locationDetailsForm.get('txtPincode').errors);

                    this.minPincode = 0
                    this.maxPincode = 0
                    this.minPincode = this.utilities.getMinLength(pattern)
                    this.maxPincode = this.utilities.getMaxLength(pattern)

                    // Set the validators for the pincode field
                    pincodeControl.setValidators([
                        Validators.pattern(pattern),
                        Validators.minLength(this.minPincode),
                        Validators.maxLength(this.maxPincode)
                    ]);
                } else {
                    pincodeControl.setValidators([PincodeValidation]);
                }
                pincodeControl.updateValueAndValidity();
            }
        }
    }

    openAddModel(mappingId?: any) {
        const ngbModalOptions: NgbModalOptions = {
            ariaLabelledBy: 'modal-basic-title',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            centered: true
        };
        const modalRef = this.modalService.open(AddODAComponent, ngbModalOptions);
        modalRef.componentInstance.mappingId = mappingId;
        modalRef.result.then(
            (reason) => {
                if (reason === 'Save click') {
                    // this.getAllODAList();
                    this.searchODA(true);
                }
            },
            (reason) => {
                if (reason == 'Cross click') {
                }
            }
        );
    }

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.setDomLayout("autoHeight");
        params.api.sizeColumnsToFit();
    } 

    editAction(cell: any) {
        try {
            if (!this.permConfig.isEditAllowed) {
                this.warningDialog('No access to Edit.');
            }
            else if (this.permConfig.isEditAllowed && cell && cell.id) {
                this.openAddModel(cell.id);
            }
        } catch (e) {
            console.error(e);
        }
    }

    deleteAction(cell: any) {
        if (!this.permConfig.isDeleteAllowed) {
            this.warningDialog('No access to Delete.');
        }
        else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
            this.openConfirmationDialog('Are you sure you want to delete ?', cell.id);
        }
    }

    deleteRecord(id) {
        try {
            if (id) {
                this.ngxLoaderService.start();
                this.chargesService.DeleteODA(id).subscribe((res) => {
                    if (res && res.success) {
                        this.ngxLoaderService.stop();
                        this.appCoreService.showMessage('Record deleted successfuly', 'Success', 'success');
                        this.searchODA(true);
                    } else if (res && !res.success) {
                        this.ngxLoaderService.stop();
                        this.appCoreService.showMessage(res.message, 'Cannot delete !', 'error')
                    }
                });
            }
        } catch (e) {
            this.ngxLoaderService.stop();
            console.error(e);
        }
    }

    async openConfirmationDialog(msg: any, id?: number) {
        const result = await Swal.fire({
            titleText: 'Confirmation',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'Yes',
            showDenyButton: true,
            denyButtonText: 'No',
            allowEscapeKey: false,
            allowOutsideClick: false
        });
        if (result.isConfirmed) {
            this.deleteRecord(id);
        }
    }

    pincodeFormatter = (x: { pincode: string }) => x.pincode;

    searchODA(pageload = false) {
        try {
            if (this.odaChargesForm.valid) {
                const picodeObj = this.odaChargesForm.get('txtPincode').value;
                const reqObj = {
                    pincode: (typeof picodeObj === 'string') ? picodeObj : picodeObj?.pincode,
                    customerid: this.odaChargesForm.get('ddlCustomer').value,
                    vendorid: this.odaChargesForm.get('ddlVendor').value,
                    serviceid: this.odaChargesForm.get('ddlService').value,
                    countryisocode: this.odaChargesForm.get('ddlCountry').value,
                    stateisocode: this.odaChargesForm.get('ddlState').value,
                    cityisocode: this.odaChargesForm.get('ddlCity').value,
                    pageload: pageload
                };

                this.ngxLoaderService.start();
                this.chargesService.SearchODA(reqObj).subscribe((res) => {
                    if (res && res.success) {
                        this.ngxLoaderService.stop();
                        this.rowData = res.data;
                        this.resetForm();
                    } else if (res && res.success == false) {
                        // console.log(res);
                        this.ngxLoaderService.stop();
                        const msg = res.message;
                        this.errDialog(msg);
                    }
                });
            }
        } catch (e) {
            console.error(e);
            this.ngxLoaderService.stop();
        }
    }

    searchPincode: OperatorFunction<string, readonly { pincode; flag }[]> = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map((term) =>
                term === ''
                    ? []
                    : this.pincodeList.filter((v) => v.pincode.toLowerCase().startsWith(term.toLowerCase())).slice(0, 10),
            ),
        );

    async onPincodeChanged() {
        try {
            const pinObj = this.odaChargesForm.get('txtPincode').value;
            if (typeof pinObj == 'string') {
                this.odaChargesForm.get('txtPincode').setValidators([PincodeValidation]);
            } else {
                this.odaChargesForm.get('txtPincode').clearValidators();
            }
            this.odaChargesForm.get('txtPincode').updateValueAndValidity();
            if (typeof pinObj != 'string') {
                this.odaChargesForm.get('ddlCountry').setValue(pinObj.countryisocode);
                await lastValueFrom(from(this.bindStatesByCountry(pinObj.countryisocode)));
                await lastValueFrom(from(this.bindCitiesByState(pinObj.stateisocode)));
                this.odaChargesForm.get('ddlState').setValue(pinObj.stateisocode);
                this.odaChargesForm.get('ddlCity').setValue(pinObj.cityisocode);
            }
        } catch (error) {
            console.error(error);
        }
    }

    async bindStatesByCountry(countryCode?: string): Promise<void> {
        try {
            if (countryCode) {
                const observable = this.geoService.GetAllStates({ countrycode: countryCode });
                const res = await lastValueFrom(observable);
                if (res && res.success) {
                    this.stateList = res.data;
                    this.countryCode = countryCode;
                } else {
                    throw new Error('Error fetching data');
                }
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    async bindCitiesByState(stateCode?: string): Promise<void> {
        try {
            if (stateCode) {
                const observable = this.geoService.GetAllCities({ statecode: stateCode });
                const res = await lastValueFrom(observable);
                if (res && res.success) {
                    this.cityList = res.data;
                } else {
                    throw new Error('Error fetching data');
                }
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    bindCountries() {
        try {
            this.geoService.GetAllCountries().subscribe((res) => {
                if (res && res.success) {
                    this.countryList = res.data;
                }
            });
        } catch (e) {
            console.error(e);
        }
    }

    onCountryChange() {
        const selectedValue = this.odaChargesForm.get('ddlCountry').value;
        if (selectedValue) {
            this.bindStatesByCountry(selectedValue);
            this.stateList = []; this.cityList = [];
            this.odaChargesForm.get('ddlState').reset();
            this.odaChargesForm.get('ddlCity').reset();
        }
    }

    onStateChange() {
        const selectedValue = this.odaChargesForm.get('ddlState').value;
        if (selectedValue) {
            this.bindCitiesByState(selectedValue);
            this.cityList = [];
            this.odaChargesForm.get('ddlCity').reset();
        }
    }

    bindPincodes() {
        this.geoService.GetAllPincodes().subscribe((res) => {
            if (res && res.success) {
                this.pincodeList = res.data;
            }
        });
    }

    getAllCustomers() {
        try {
            this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter, isactive: true }).subscribe((res) => {
                if (res && res.success) {
                    this.customerList = res.data;
                }
            })
        } catch (error) {

        }
    }

    async getAllVendors() {
        const res = await lastValueFrom(this.vendorService.GetAll({ isactive: true }));
        res?.success ? this.vendorList = res.data : [];
    }

    async bindService() {
        const id = this.odaChargesForm.get('ddlVendor').value;
        this.odaChargesForm.get('ddlService').reset();
        const res = await lastValueFrom(this.vendorService.GetAllListByVendor({ id: id }));
        this.serviceList = res?.success ? res.data : null;
    }

    onChangeChargeType() {
        this.isFormSubmitted = false;
        this.odaChargesForm.get('ddlCustomer').reset();
        this.odaChargesForm.get('ddlVendor').reset();
        this.odaChargesForm.get('ddlService').reset();
        this.chargeType = this.odaChargesForm.get('ddlType').value;
        const vendor = this.odaChargesForm.get('ddlVendor').value;
        vendor ? this.odaChargesForm.get('ddlCustomer').disable() : this.odaChargesForm.get('ddlCustomer').enable();
        if (this.chargeType == 'Vendor') {
            this.odaChargesForm.get('ddlCustomer').setValue(null);
            this.odaChargesForm.get('ddlCustomer').disable();
            this.odaChargesForm.get('ddlCustomer').clearValidators();
            this.odaChargesForm.get('ddlVendor').setValidators([Validators.required]);
            this.CustomerType = false;
        } else if (this.chargeType == 'Tariff') {
            this.odaChargesForm.get('ddlCustomer').setValue(null);
            this.odaChargesForm.get('ddlCustomer').disable();
            this.odaChargesForm.get('ddlCustomer').clearValidators();
            this.odaChargesForm.get('ddlVendor').clearValidators();
            this.CustomerType = false;
        }
        else {
            this.odaChargesForm.get('ddlCustomer').enable();
            this.odaChargesForm.get('ddlVendor').clearValidators();
            this.odaChargesForm.get('ddlCustomer').setValidators([Validators.required]);
            this.CustomerType = true;
        }
        this.odaChargesForm.get('ddlCustomer').updateValueAndValidity();
        this.odaChargesForm.get('ddlVendor').updateValueAndValidity();
    }

    async openSucessDialog(msg: any) {
        const result = await Swal.fire({
            title: 'Success!',
            text: msg,
            icon: 'success',
            confirmButtonText: 'Ok',
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }

    warningDialog(msg: any) {
        Swal.fire({
            title: 'Warning!',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }

    async errDialog(msg: any) {
        await Swal.fire({
            title: 'Opps!',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'Ok',
            allowEscapeKey: false,
            allowOutsideClick: false
        })
    }

    blockFormSubmit() {
        return false;
    }

    resetForm() {
        this.isFormSubmitted = false;
        this.editMode = false;
        this.odaChargesForm.reset();
        this.Id = null;
    }

    exportExcel() {
        if (this.rowData.length) {
            const formattedData = this.rowData.map(item => {
                const formattedItem = {};
                for (const key in item) {
                    if (item.hasOwnProperty(key)) {
                        formattedItem[key.toUpperCase()] = item[key];
                    }
                }
                return formattedItem;
            });

            this.excelService.exportAsExcelFile(formattedData, 'ODA_pincodes');
        }
        else {
            this.appCoreService.showMessage("No data to export", '', 'error');
        }
    }

    formatData(data: any) {
        let formatedData: any[] = [];
        formatedData = data;
        // for (var i =0; i< data; i++) {
        //     reports.push(data[i]);
        //     // reports.push({
        //     //     'Awb Number': report.awbnumber,
        //     //     'Weight': report.actualweight,
        //     //     'Booking Date': report.bookingdate,
        //     //     'Shipper': report.shippername,
        //     //     'Consignee': report.consigneename,
        //     //     'Company': report.companyname,
        //     //     'Customer': report.customername,
        //     //     'Vendor': report.vendorname,
        //     //     'Service': report.servicename,
        //     //     'Product': report.productname,
        //     //     'Origin Country': report.origincountry,
        //     //     'Origin State': report.originstate,
        //     //     'Origin City': report.origincity,
        //     //     'Destination Country': report.destinationcountry,
        //     //     'Destination State': report.destinationstate,
        //     //     'Destination City': report.destinationcity,
        //     //     'Transaction Status': report.transactionstatus
        //     // });
        // }
        return formatedData;
    }
}